import React from "react";
import { Breadcrumbs } from "@mui/material";
import { useDispatch } from "react-redux";
import { openSideBar } from "../../../app/features/sidebar/sidebarSlice";

type BreadcrumbProps = {
  pageNameList: string[];
};

const Breadcrumb = ({ pageNameList }: BreadcrumbProps) => {
  const dispatch = useDispatch();
  const handleClick = (e: any) => {
    dispatch(openSideBar());
  };

  const breadcrumbs = pageNameList.map((name) => (
    <p style={{ cursor: "pointer" }} onClick={handleClick} key={name}>
      {name}
    </p>
  ));

  return (
    <Breadcrumbs
      separator="››"
      aria-label="breadcrumb"
      sx={{
        fontWeight: "500",
        color: "primary.main",
        fontSize: 18,
        mt: -2,
      }}
    >
      {breadcrumbs}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
